import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import HmimhwPropertySearch$1 from '@zillow/hmimhw-property-search';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

var HmimhwPropertySearchWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1lzwlpq-0"
})(["max-width:100%;width:720px;"]);
var PUBLIC_CONFIG_VALUES_MAP = {
  test: {
    addressAutocompleteURL: 'https://static.qa.zillow.net/autocomplete/v3/suggestions/',
    gdpServiceUrl: 'https://www.qa.zillow.net/graphql/',
    zatlasEndpoint: 'https://proxy.dev.zillow.net/develop/'
  },
  prod: {
    addressAutocompleteURL: 'https://www.zillowstatic.com/autocomplete/v3/suggestions/',
    gdpServiceUrl: 'https://www.zillow.com/graphql/',
    zatlasEndpoint: 'https://proxy.zillowapi.com/prod/'
  }
};
var BlockHmimhwPropertySearch = function BlockHmimhwPropertySearch(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var NEXT_PUBLIC_ENV = process.env.NEXT_PUBLIC_ENV;
  return /*#__PURE__*/React.createElement(HmimhwPropertySearchWrapper, null, /*#__PURE__*/React.createElement(HmimhwPropertySearch$1, _extends({
    key: index,
    publicConfigValues: PUBLIC_CONFIG_VALUES_MAP[NEXT_PUBLIC_ENV] || PUBLIC_CONFIG_VALUES_MAP.test,
    isLightboxBackgroundLocked: false
  }, attrs)));
};
BlockHmimhwPropertySearch.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    placementId: PropTypes.string,
    surfaceId: PropTypes.string,
    xConsumerUsername: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var HmimhwPropertySearch = BlockHmimhwPropertySearch;

export { HmimhwPropertySearch as default };
